module.exports = __webpack_public_path__ + "img/block-2.71d58f2a.png";